import React, {useEffect, useState} from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import {SelectDs} from 'lib.front';
import {DatePicker} from '@mui/x-date-pickers';
import {monedas} from '../constants/constantes';
import {makeStyles} from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
   datePicker: {
      width: '-webkit-fill-available'
   },
   input: {
      maxWidth: '500px',
   }
}));
const TipoCambioDialog = ({
   open,
   onClose,
   onSubmit,
   tipoCambioForm,
   tipoCambioFormErrors,
   handleFormChange,
   modo // 'edit' o 'create'
}) => {
   const {classes, cx} = useStyles();
   return (
      <Dialog open={open} onClose={onClose}>
         <DialogTitle style={{paddingInline: '24px'}}>
            <Typography variant="h3" component="span">
               {modo === 'edit' ? 'Editar' : 'Nuevo'} Tipo de Cambio
            </Typography>
         </DialogTitle>
         <DialogContent>
            <Grid item xs={12} container spacing={1}>
               <Grid item xs={6}>
                  <DatePicker
                     name="fecha"
                     margin="dense"
                     label="Fecha"
                     format="dd/MM/yyyy"
                     value={tipoCambioForm.fecha}
                     onChange={e => handleFormChange('fecha', e)}
                     inputVariant="outlined"
                     KeyboardButtonProps={{
                        'aria-label': 'elegir fecha'
                     }}
                     maxDate={new Date()}
                     fullWidth
                     disabled={modo == 'edit'}
                     sx={{marginTop: '8px'}}
                     className={cx(classes.input, classes.datePicker)}
                  />
               </Grid>
               <Grid item xs={6}>
                  <SelectDs
                     name="codMoneda"
                     label="Moneda"
                     variant="outlined"
                     value={tipoCambioForm.codMoneda}
                     onChange={e => handleFormChange('codMoneda', e.target.value)}
                     margin="dense"
                     data={monedas}
                     error={tipoCambioFormErrors.codMoneda !== ''}
                     helperText={tipoCambioFormErrors.codMoneda}
                     genItemValue={item => item.codMoneda}
                     genItemKey={item => item.codMoneda}
                     genItemLabel={item => {
                        return `${item.codMoneda} - ${item.simbolo}`;
                     }}
                     fullWidth
                     disabled={modo == 'edit'}
                     className = {classes.input}
                  />
               </Grid>
               <Grid item xs={6}>
                  <TextField
                     name="compraFiscal"
                     value={tipoCambioForm.compraFiscal}
                     onChange={e => handleFormChange('compraFiscal', e.target.value)}
                     label="T.C. Compra"
                     variant="outlined"
                     margin="dense"
                     fullWidth
                     onFocus={event => event.target.select()}
                     error={tipoCambioFormErrors.compraFiscal !== ''}
                     helperText={tipoCambioFormErrors.compraFiscal}
                     type="number"
                     inputProps={{
                        step: '0.001',
                        min: '0'
                     }}
                     className = {classes.input}
                  />
               </Grid>
               <Grid item xs={6}>
                  <TextField
                     name="ventaFiscal"
                     value={tipoCambioForm.ventaFiscal}
                     onChange={e => handleFormChange('ventaFiscal', e.target.value)}
                     label="T.C. Venta"
                     variant="outlined"
                     margin="dense"
                     fullWidth
                     onFocus={event => event.target.select()}
                     error={tipoCambioFormErrors.ventaFiscal !== ''}
                     helperText={tipoCambioFormErrors.ventaFiscal}
                     type="number"
                     inputProps={{
                        step: '0.001',
                        min: '0'
                     }}
                     className = {classes.input}
                  />
               </Grid>
            </Grid>
         </DialogContent>
         <DialogActions
            style={{justifyContent: 'space-between', paddingInline: '24px', paddingBottom: '16px'}}
         >
            <Grid item xs={3}>
               <Button variant="outlined" autoFocus onClick={onClose} fullWidth>
                  Cancelar
               </Button>
            </Grid>
            <Grid item xs={3}>
               <Button variant="contained" onClick={onSubmit} fullWidth>
                  {modo === 'edit' ? 'Grabar' : 'Crear'}
               </Button>
            </Grid>
         </DialogActions>
      </Dialog>
   );
};
export default TipoCambioDialog;
